export const mail = (
  <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 3.5L7.5 7.5L14.5 3.5M1.5 0.5H13.5C14.0523 0.5 14.5 0.947715 14.5 1.5V11.5C14.5 12.0523 14.0523 12.5 13.5 12.5H1.5C0.947716 12.5 0.5 12.0523 0.5 11.5V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5Z"
      stroke="white"
    />
  </svg>
);
